import axios from 'axios';
import { GlobalError } from 'components/errors/GlobalError';
import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom';
import { RefreshUserInfo } from 'store/actions/userActions/RefreshUserInfo';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { generateConfig, refreshTokenHandler } from 'utilityFunctions';
import { DISABLE_NAVIGATION } from "../store/actions/actionTypes/types";
import useApplicationInfo from './useAppInfo';


export const useReadNotification = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { accessToken, refreshToken, userInfo, currentlyPolling } = useAppSelector(
    (state) => state.auth
  );
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const {application, applicationVersion} = useApplicationInfo();

  const readNotification = async (
    notificationId: string | "clear",
    config: any
  ) => {
    let url: string;
    if (notificationId === "clear") {
      url = `${BASE_URL}/api/users/notifications/clear`;
    } else url = `${BASE_URL}/api/users/notifications/${notificationId}`;
    return axios.patch(url, {application, applicationVersion},  config);
  };

  return useMutation(
    (notificationId: string) => {
       dispatch({type: DISABLE_NAVIGATION, payload: true});
      const config = generateConfig(accessToken);
      return readNotification(notificationId, config);
    },
    {
      onSuccess: (response: any) => {
       dispatch(RefreshUserInfo(accessToken, refreshToken, userInfo, navigate, currentlyPolling))
       dispatch({type: DISABLE_NAVIGATION, payload: false});
      },

      onError: async (
        error: any,
      notificationId: string
      ) => {
        if (!!error.response && error.response.status === 401) {
          const refreshedTokens = await refreshTokenHandler(
            refreshToken,
            userInfo,
            dispatch,
            navigate
          );
          const refreshedConfig = generateConfig(refreshedTokens?.accessToken);
          
          const url = `${BASE_URL}/api/users/notifications/${notificationId}`;
          try {
            const readNotificationResponse = await axios.patch(
              url,
              {application, applicationVersion},
              refreshedConfig
            );
            if (readNotificationResponse.status === 200) {
               dispatch(RefreshUserInfo(refreshedTokens?.accessToken!, refreshedTokens?.refreshToken!, userInfo, navigate, currentlyPolling))
               dispatch({type: DISABLE_NAVIGATION, payload: false});
              }
          } catch (error) {
            dispatch({type: DISABLE_NAVIGATION, payload: false});
            GlobalError(error);
          }
        } else {
          dispatch({type: DISABLE_NAVIGATION, payload: false});
          GlobalError(error);
        }
      },
    }
  );
};